import React from 'react';
import { Box, Button, Typography, Paper, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const DocumentViewDemo: React.FC = () => {
  const navigate = useNavigate();

  const demoDocuments = [
    { id: '1', title: 'Normal Document', description: 'Shows a complete document with all sections' },
    { id: 'error-no-workflow', title: 'No Workflow Match', description: 'Document that doesn\'t match any workflow' },
    { id: 'error-processing', title: 'Processing Error', description: 'Document with processing errors' },
    { id: 'not-found', title: 'Not Found', description: 'Demonstrates document not found error' }
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Document View Demo
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Click on any document below to view different states of the Document View component:
      </Typography>

      <Stack spacing={2}>
        {demoDocuments.map((doc) => (
          <Paper key={doc.id} sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography variant="h6">{doc.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {doc.description}
                </Typography>
              </Box>
              <Button
                variant="contained"
                onClick={() => navigate(`/documents/${doc.id}`)}
              >
                View Document
              </Button>
            </Box>
          </Paper>
        ))}
      </Stack>

      <Box sx={{ mt: 4 }}>
        <Button variant="outlined" onClick={() => navigate('/documents')}>
          Back to Documents List
        </Button>
      </Box>
    </Box>
  );
};

export default DocumentViewDemo;
